const translationActions = {
  SET_LANGUAGE: 'SET_LANGUAGE'
} as const

export default translationActions
